<template>
    <div id="List1" class="scroller-wrapper scroll-vertical">
      <div id="Scroller">
        <div id="BannerContainer" @click="BannerClick()"
             v-if="Banners.length>0">
          <transition :enter-active-class="'slideIn'+BannerInDirecter"
                      :leave-active-class="'slideOut'+BannerOutDirecter">
            <img @touchstart="BannerTouchStart($event)"
                 @touchend="BannerTouchEnd($event)"
                 :key="thisBanner"
                 class="animated"
                 :src="require('../../assets/1st/Articles/Article_'+Banners[thisBanner-1]+'/lunbo.jpg')">
          </transition>
          <div id="BannerPointContainer" v-if="Banners.length>1"
               :style="BannerPointContainerStyle">
            <div v-for="p in Banners.length" class="BannerPoint" :class="{BannerPointSelect:thisBanner==p}"></div>
          </div>
        </div>
        <div id="ArticleContainer">
          <div class="ArticleBar" @click="viewArticle(a)"
               v-for="a in ThisList">
            <div class="ArticleIMG">
              <img :src="require('../../assets/1st/Articles/Article_'+a+'/cover.jpg')">
            </div>
            <div class="ArticleTitle">
              {{AllList[a].title}}
            </div>
            <div class="ArticleSecondTitle">
<!--              {{AllList[a].SecondTitle}}-->
            </div>
            <div class="ArticleDate">
              {{AllList[a].date}}
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import store from '../../store/1st'
  export default {
    name: "List1",
    store,
    data:function(){
      return {
        thisBanner:1,
        IntervalID:0,
        touchVal:{x:0,y:0},
        BannerInDirecter:"Right",
        BannerOutDirecter:"Left",
        scroller:0,
        AllList:[],
        ThisList:[],
        Banners:[],
      }
    },
    mounted:function() {
      this.SetBannerPlay();
      this.AllList=this.$store.state.ArticleList
      this.ThisList=this.$store.state.List1
      var scrollerConfig = {
        '//Description' : 'Default scroller with no configuration'
      };
      this.scroller = new Scroller('#List1', scrollerConfig);
      this.Banners=this.$store.state.Banner1;
    },
    methods:{
      SetBannerPlay:function(){
        this.IntervalID=setInterval(()=> {
          this.NextBaner();
        },3000)
      },
      NextBaner:function(){
        this.BannerInDirecter="Right";
        this.BannerOutDirecter="Left";
        if(this.thisBanner==this.Banners.length) this.thisBanner=1;
        else this.thisBanner++
      },
      PreBaner:function(){
        this.BannerInDirecter="Left";
        this.BannerOutDirecter="Right";
        if(this.thisBanner==1) this.thisBanner=this.Banners.length;
        else this.thisBanner--
      },
      BannerTouchStart:function (e) {
        this.touchVal.x=e.touches[0].clientX
      },
      BannerTouchEnd:function (e) {
        let limit=this.$store.state.WindowSize.WindowWidth*0.15;
        if(e.changedTouches[0].clientX-this.touchVal.x>limit){
          clearInterval(this.IntervalID)
          this.PreBaner()
          this.SetBannerPlay()
        }
        if(e.changedTouches[0].clientX-this.touchVal.x<(-1*limit)){
          clearInterval(this.IntervalID)
          this.NextBaner()
          this.SetBannerPlay()
        }
      },
      viewArticle(id){
        this.$store.commit('PushArticle',id);
        this.$router.replace("/Article/"+id)
      },
      BannerClick(){
        let id=this.Banners[this.thisBanner-1]
        this.viewArticle(id);
      }
    },
    computed:{
      BannerPointContainerStyle(){
        return {
          width: 4.2*this.Banners.length+'rem',
          left:(112.5-(4.2*this.Banners.length))/2+'rem'
        }
      }
    }
  }
</script>

<style scoped>
  #List1{
    width: 100%;
    height: 100%;
    background: #f7f7f7;
  }
  #Scroller{
    width: 100%;
  }
  #BannerContainer{
    position: relative;
    width: 112.5rem;
    height: 63.4rem;
    overflow: hidden;
  }
  #BannerContainer img{
    position: absolute;
    width: 112.5rem;
  }
  #BannerPointContainer{
    position: absolute;
    height: 4.2rem;
    top:57.2rem;
  }
  .BannerPoint{
    width: 2rem;
    height: 2rem;
    border-radius: 1rem;
    margin: 1.1rem;
    background: #4136ff;
  }
  .BannerPointSelect{
    background: #ffffff;
  }

  #ArticleContainer{
    width: 100%;
    padding-bottom: 15rem;
  }
  .ArticleBar{
    width: 103.5rem;
    height: 28.4rem;
    margin-left: 4.5rem;
    margin-top: 4.5rem;
    background: #fff;
    border-radius: 4.5rem;
    overflow: hidden;
    box-shadow: 0rem 0rem 2rem 0.1rem #ccc;
  }
  .ArticleIMG{
    width: 28.1rem;
    height: 28.4rem;
    overflow: hidden;
  }
  .ArticleIMG img{
    height: 100%;
  }
  .ArticleTitle{
    width: 66.4rem;
    height: 10rem;
    line-height: 5rem;
    font-size: 4rem;
    margin-left: 4.5rem;
    margin-right: 4.5rem;
    margin-top: 3rem;
  }
  .ArticleSecondTitle{
    width: 66.4rem;
    height: 6.6rem;
    line-height: 3.3rem;
    font-size: 2.7rem;
    margin-left: 4.5rem;
    margin-right: 4.5rem;
    margin-top: 1.7rem;
    color: #989898;
  }
  .ArticleDate{
    width: 66.4rem;
    height: 2.1rem;
    line-height: 2.1rem;
    font-size: 2.1rem;
    margin-left: 4.5rem;
    margin-right: 4.5rem;
    margin-top: 2.5rem;
    color: #989898;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/List1.vue